export default {
  layout: {
    copyright: 'Copyright @ Drama Action. All rights reserved.',
  },
  tabBar: {
    aboutUs: '關於我們',
    activities: '活動資訊',
    service: '輔導服務',
    album: '活動花絮',
    contactUs: '聯絡我們',
    facebook: 'Facebook',
  },
  home: {
    training: '公司培訓',
    school: '學校／社區關懷',
    happyMonday: 'Happy Monday',
    drama: '力克劇團',
    phone: '身心靈專線',
    train: '義工列車',
    recruiting: '了解詳情',
    desc: '<span id="t1">戲</span><span id="t2">像</span><span id="t3">學</span><span id="t4">堂</span>的成立，' +
      '旨在提供專業且全面的戲劇教育服務予本地不同的單位、教育機構及社區組織，' +
      '如幼稚園、小學、中學、大專、社區中心、社會服務機構以至各個有興趣認識戲劇的單位。' +
      '戲劇教育已逐漸普及，不同單位和組織均有舉行各式各樣的戲劇教育工作坊、演出與訓練，' +
      '以達致各項目的，如語言、德育、個人成長、團隊合作，以至社區與群體對特定議題的深入探討，' +
      '我們正好為各機構提供一個更專業、更靈活、更富探索空間和更富教育意義的選擇。',
  },
  aboutUs: {
    ambition: '我們的使命',
    categories: '活動類別',
    founder: '創辦人',
    organizations: '合作機構',
    media: '傳媒報導',
    para1: '<span id="t1">戲</span><span id="t2">像</span><span id="t3">學</span><span id="t4">堂</span>的成立，' +
      '旨在提供專業且全面的戲劇教育服務予本地不同的單位、教育機構及社區組織，' +
      '如幼稚園、小學、中學、大專、社區中心、社會服務機構以至各個有興趣認識戲劇的單位。' +
      '服務層面由幼兒至長者，不同群體皆十分歡迎，只因我們相信戲劇可作為每一個人發聲的媒介，' +
      '是一種成長，是一種肯定，更是一種關懷。',
    para2: '有見近年本港的戲劇教育已逐漸普及，不同單位和組織均有舉行各式各樣的戲劇教育工作坊、' +
      '演出與訓練，以達致各項目的，如語言、德育、個人成長、團隊合作，以至社區與群體對特定議題的深入探討，' +
      '我們正好為各機構提供一個更專業、更靈活、更富探索空間和更富教育意義的選擇。',
    para3: '然而，正由於戲劇教育服務如雨後春筍般出現，我們更要為希望進行的項目，' +
      '從戲劇排演、演技訓練班、過程戲劇等等，不同種類的戲劇教育方式中，選擇最適切的一種，' +
      '以期獲得最佳的教育效果。我們正希望藉我們成員對戲劇教育的經驗與學識，' +
      '一方面擴闊大眾對戲劇教育這體驗式學習的認識；同時進行更多富有意義的戲劇教育工作坊及演出，' +
      '讓不同崗位的參與者從中領會更深刻和深遠的教育意義，促進對主題的認識與反思。',
    categoriesTitle: '提供豐富，多樣的活動及課程',
    categoriesTitleMobile: '多樣的活動及課程',
    rickChow: '周煐傑  Rick Chow',
    para4: '畢業於香港理工大學社工學系，澳洲格理菲斯大學獲應用劇場戲劇教育碩士、' +
      '國際認可大笑瑜伽老師、美國PCSI Facilitator (Corporate Coach U - PCSI Clinic)' +
      '及性格透視® Level 1培訓導師、註冊行為表現分析師 (TTI - CPBA)、' +
      '註冊激勵因子分析師 (TTI - CPMA)、認可催眠治療導師 (HACAOA)、註冊情緒智能分析師 (TTI - CPEQA) 及註冊人生教練等等資歷',
    para5: '曾任職青少年中心資深社工(為隱蔽青年進行動物輔助治療)、' +
      '曾任St . James Settlement客席導師、明愛毅進課程老師(教授香港社會政策)、' +
      '三間兼職學校社工、香港教育大學的社工系實習督導老師等等。' +
      '現任戲像學堂藝術總監、' +
      '富達盟信顧問有限公司培訓師及熱線輔導社工、' +
      '越己堂兼任職戲劇培訓師及共融教室兼任職戲劇培訓師(對象為學障學生)。',
    para6: '曾於香港青年協會及中華錫安傳道會開辦”讀心術自我提昇訓練班”，' +
      '以行為心理學為理論基礎。仍有舉辦其他課程如九型人格、心理投射繪圖技法、' +
      '顏色心理學、催眠課程、敘事式生命故事輔導、專業教練方法及NLP等等,',
    para7: '曾完成課程：心理投射測驗分析技巧( Psy-Ed Consultants Company)、' +
      '專業教練學基礎証書課程(聖雅各褔群會)、九型人格進修課程(Dr.Unico)、' +
      '顏色心理學及微表情讀心術(工聯會)',
    para8: '執教經驗豐富單位亦包括各中、小學及社福機構，' +
      '香港祟真會『夢想年華』舞台劇、力克藝團『教獄』論壇劇場、' +
      '上水明愛ICCMW明愛童心藝伴行入校演出計劃、明愛聖若瑟中學『OLE戲劇全方位導演課程』、' +
      '保良局葵涌綜合復康中心『平等大舞台』、基督教香港信義會社會服務部天水圍青少年綜合服務中心『天使護航』、' +
      '香港聖公會將軍澳安老服務大樓『大快活』劇團的論壇劇場、循理會白普理德田長者服務中心編劇班、' +
      '竹園區神召會彩雲長者鄰舍中心劇團的論壇劇場、' +
      '曾義務協助樂施會筆錄八節”戲中探貧窮”教育劇場的程序及輯印成書，' +
      '及曾為沙田話劇團演出”望夫山下望夫歸”劇目',
    para9: '多年來Rick的劇場經驗更包括課程總監、編劇、導演、演員、舞台監督、' +
      '佈景設計等多個台前幕後崗位，熟悉舞台運作。帶領數十個劇場、' +
      '戲劇教育及社區劇場方面的專業課程與工作坊。',
    partners: '合作伙伴：',
    partnerMA: '銘禧藝術Millennium Arts',
    partnerGZ: '廣州同行文化發展有限公司',
    organizationsTitle: '本公司曾與／現與以下機構合作：',
    school: '學校：',
    entrepreneur: '企業／非牟利機構：',
    school1: '保良局馬錦明夫人章馥仙中學',
    school2: '聖安當中學',
    school3: '天水圍循道衛理小學',
    school4: '沙田覺光中學',
    school5: '軒尼斯官立小學',
    school6: '李福慶中學',
    school7: '羅氏基金中學',
    school8: '西貢鄭植之中學',
    school9: '浸信會永隆中學',
    school10: '音樂農莊教室',
    school11: '博愛醫院歷屆總理聯誼會鄭任安夫人千禧小學',
    school12: '馬鞍山聖若瑟小學',
    school13: '東華三院馮黃鳳亭中學',
    school14: '嶺南中學',
    school15: '新法書院',
    school16: '官立嘉道理爵士中學',
    school17: '灣仔循道衛理中學',
    school18: '九江商會學校',
    school19: '香港中文大學校友會聯會陳震夏中學',
    school20: '廠商會中學',
    school21: '香港藝術學院',
    school22: '仁濟醫院林伯欣中學',
    co1: '中華電力有限公司(突破自我訓練)',
    co2: 'AIA 投資及保險小隊(溝通力訓練)',
    co3: '現代美容中心',
    co4: '香港大學勵志計劃',
    co5: '紡織染工會(香港旭暉社)',
    co6: '香港祟真會沙田青少年綜合服務中心',
    co7: '香港青年協會(日出康城)',
    co8: '屯門區婦女會',
    co9: '屯門仁愛堂',
    co10: '嶺南大學優化專上校園生活系列工作坊',
    co11: '天水圍信義會',
    co12: '沙田婦女會',
    co13: '語言障礙支援中心',
    co14: '沙田YWCA',
    co15: '循理會德田長者服務中心',
    co16: '聖羅撒書院',
    co17: '樂智協會',
    co18: '香港痙攣協會石圍角家長資源中心',
    co19: '竹園區神召會秀茂坪好鄰舍家庭中心',
    co20: '香港耀能協會(樂富家居綜合服務隊)',
    co21: '保良局張麥珍耆樂中心',
    co22: '家庭學習協會',
    co23: '保良局葵涌綜合服務中心',
    co24: '保良局天水圍綜合服務中心',
    co25: '保良局盧邱玉霜耆暉中心田家炳長幼天地',
    co26: '香港中華基督教青年會佐敦會所',
    report1: '《我的斜槓人生》',
    source1: 'TTM LINK 2017.05',
    report2: '《助人自助的理念...》',
    source2: 'TTM LINK 2017.05',
    report3: '《學習勇敢表達》',
    source3: '經濟日報 2017.05',
    report4: '《學戲劇教導小朋友》',
    source4: 'TTM LINK 2017.05',
    report5: '《Slash一族》',
    report6: '《應用劇場@廣州》',
    source6: 'NEWS 2018.01',
    report7: '《介紹催眠》',
    report8: '《心理劇場@莘村》',
    source8: 'NEWS 2016.12',
    report9: '《性格透視體驗》',
    source9: '同行文化 2018.11',
    readClipping: '查看剪報',
    listenProgram: '收聽節目',
  },
  activities: {
    detail: '了解詳情',
    participate: '報名參加',
  },
  service: {
    title1: '經驗豐富',
    title2: '核心服務',
    title3: '收費相宜',
    title4: '助你轉化心靈困局',
    desc1: '情緒會傷人，更會影響我們的個人、工作、婚姻、家庭等等方面。' +
      '戲像學堂本著人需要被愛的核心價值，協助受情緒困擾的人士得到轉化，' +
      '重新得力去面對未來的挑戰，追求自己創造的生活。由擁有資深社工資歷，' +
      '及其他專業輔導資格的戲劇教育培訓及催眠治療師主理，' +
      '以同行者身份提供優質但收費相宜的心理輔導及治療服務。',
    features: '輔導治療特色',
    desc2: '協助受助者找出問題根源，徹底根治問題。' +
      '很多問題的成因是由於過去的成長歷程及經驗所形成，若只解決問題的表面，' +
      '而不找出問題的源頭，不同的問題只會重複出現。故此我們會利用多元藝術作介入手法，' +
      '協助受助者尋回自己的寶貴資源，自行轉化心情，得到新的啟示，改變其狀態，' +
      '增加行動力並嘗試處理自己的問題。',
    include: '服務包括',
    phoneOrInterview: '電話或面談均可',
    problem1: '青少年成長問題',
    problem2: '婚姻及家庭問題',
    problem3: '情緒困擾',
    problem4: '沉溺行為輔導',
    problem5: '人際衝突調解',
    problem6: '兩代關係衝突調解',
    problem7: '生涯發展',
    problem8: '有效溝通技巧',
    problem9: '親子關係(兒童發展與管教)',
    problem10: '兩性相處',
    problem11: '個人潛能發掘',
    problem12: '壓力處理',
    problem13: '解決問題思維與技巧',
    problem14: '創業與實現夢想',
    pricingDetail: '收費詳情',
    pricing1: '資深註冊社工、認可催眠治療師 $700/小時',
    pricing2: '第一次面談有半價優惠',
    pricing3: '如低收入人士或有特別需要人士，費用可再商議',
    pricing4: '資深註冊社工Rick Chow擁有超過10年的輔導經驗',
    emailInfo: '若想查詢我們的服務，請於電郵詳述：',
    info1: '求助問題',
    info2: '目前你的感受及障礙',
    info3: '經輔導後，你渴望得到的結果或改變',
    info4: '你的聯絡電話及電郵',
    info5: '最適合聯絡你的時段',
  },
  activityDetail: {
    back: '返回',
  },
  contact: {
    name: '名字',
    email: '電郵地址',
    subject: '標題',
    content: '內容',
    moreDetail1: '若想進一步了解，歡迎致電或透過電郵',
    moreDetail2: '與我們聯繫',
    send: '發送',
  },
  validator: {
    messages: {
      email: () => '格式錯誤',
      required: () => '不能留空',
    },
  },
};



// WEBPACK FOOTER //
// ./src/locale/zh-hk.js